import React, { useEffect } from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'

import { withModal } from '../../common/Modal/Modal'
import Image from '@components/common/Image/Image'
import Pressable from '../../common/Pressable/Pressable'

import styles from './BigSaleModal.module.css'

const BigSaleModal = withModal(props => {
  const { src } = props.popup

  useEffect(() => {
    props.$track.event('BigSaleModal', 'view')
  }, [props.$track])

  return (
    <Pressable className={styles.wrapper} onClick={props.onClose} ariaLabel={props.$i18n.transl('core.coupon.entryClaimOfferClose')}>
      <Image src={src} original title={props.$i18n.transl('core.coupon.entryClaimOfferClose')} />
    </Pressable>
  )
}, { showCloseButton: false })

export default withPlugin(BigSaleModal)